/**
 * Generated from ch1_p017.fla
 */
export function ch1_p017(this: Ich1_p017) {
	const lights = this.lights;
	if (!lights[0] && lights.elementFactory) {
		lights[0] = lights.elementFactory(0,undefined);
	}
	if (lights[0]) {
		ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer196.call(lights[0] as Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer196);
		lights[0].x = 1032;
		lights[0].y = 384;
		lights[0].width = 1022.00;
		lights[0].height = 768.00;
		lights[0].alpha = 1;
		if (lights[0].onLayout) lights[0].onLayout();
	}
	if (!lights[1] && lights.elementFactory) {
		lights[1] = lights.elementFactory(1,undefined);
	}
	if (lights[1]) {
		ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer196copy.call(lights[1] as Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer196copy);
		lights[1].x = 790;
		lights[1].y = 384;
		lights[1].width = 1591.50;
		lights[1].height = 768.00;
		lights[1].alpha = 0;
		if (lights[1].onLayout) lights[1].onLayout();
	}
	if (!lights[2] && lights.elementFactory) {
		lights[2] = lights.elementFactory(2,undefined);
	}
	if (lights[2]) {
		ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer196copy2.call(lights[2] as Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer196copy2);
		lights[2].x = 893;
		lights[2].y = 384;
		lights[2].width = 1397.00;
		lights[2].height = 768.00;
		lights[2].alpha = 1;
		if (lights[2].onLayout) lights[2].onLayout();
	}
	if (!lights[3] && lights.elementFactory) {
		lights[3] = lights.elementFactory(3,undefined);
	}
	if (lights[3]) {
		ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer225.call(lights[3] as Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer225);
		lights[3].x = 576.75;
		lights[3].y = 708.75;
		lights[3].width = 378.50;
		lights[3].height = 118.50;
		lights[3].alpha = 1;
		if (lights[3].onLayout) lights[3].onLayout();
	}
	if (!lights[4] && lights.elementFactory) {
		lights[4] = lights.elementFactory(4,undefined);
	}
	if (lights[4]) {
		ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer223.call(lights[4] as Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer223);
		lights[4].x = 394.5;
		lights[4].y = 197.75;
		lights[4].width = 442.00;
		lights[4].height = 405.50;
		lights[4].alpha = 1;
		if (lights[4].onLayout) lights[4].onLayout();
	}
	const texture = this.texture;
	if (!texture[0] && texture.elementFactory) {
		texture[0] = texture.elementFactory(0,undefined);
	}
	if (texture[0]) {
		ch1_p017_hh_ch1_72dpi_p017psdAssettextureLayer135.call(texture[0] as Ich1_p017_hh_ch1_72dpi_p017psdAssettextureLayer135);
		texture[0].x = 832;
		texture[0].y = 371.5;
		texture[0].width = 1664.00;
		texture[0].height = 773.00;
		texture[0].alpha = 0;
		if (texture[0].onLayout) texture[0].onLayout();
	}
	if (!texture[1] && texture.elementFactory) {
		texture[1] = texture.elementFactory(1,undefined);
	}
	if (texture[1]) {
		ch1_p017_hh_ch1_72dpi_p017psdAssettextureLayer9copy.call(texture[1] as Ich1_p017_hh_ch1_72dpi_p017psdAssettextureLayer9copy);
		texture[1].x = 832;
		texture[1].y = 389;
		texture[1].width = 1664.00;
		texture[1].height = 773.00;
		texture[1].alpha = 0;
		if (texture[1].onLayout) texture[1].onLayout();
	}
	const background = this.background;
	ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_background.call(this.background);
	background.x = 832;
	background.y = 384;
	background.width = 1664.00;
	background.height = 768.00;
	background.alpha = 1.00;
	if (background.onLayout) background.onLayout();
	const outside = this.outside;
	ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_outside.call(this.outside);
	outside.x = 867.75;
	outside.y = 367.25;
	outside.width = 306.50;
	outside.height = 621.50;
	outside.alpha = 1.00;
	if (outside.onLayout) outside.onLayout();
	const doorFrame = this.doorFrame;
	ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_doorframemask.call(this.doorFrame);
	doorFrame.x = 867.5;
	doorFrame.y = 362.25;
	doorFrame.width = 325.00;
	doorFrame.height = 631.50;
	doorFrame.alpha = 1.00;
	if (doorFrame.onLayout) doorFrame.onLayout();
	const couch = this.couch;
	ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_couch.call(this.couch);
	couch.x = 1065.5;
	couch.y = 519;
	couch.width = 1197.00;
	couch.height = 498.00;
	couch.alpha = 1.00;
	if (couch.onLayout) couch.onLayout();
	const outsideLight = this.outsideLight;
	ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_outsidelight.call(this.outsideLight);
	outsideLight.x = 855.5;
	outsideLight.y = 384.75;
	outsideLight.width = 1319.00;
	outsideLight.height = 769.50;
	outsideLight.alpha = 0.64;
	if (outsideLight.onLayout) outsideLight.onLayout();
	const holly = this.holly;
	ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_holly.call(this.holly);
	holly.x = 877;
	holly.y = 675;
	holly.width = 410.00;
	holly.height = 520.50;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const hollyShadow = this.hollyShadow;
	ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_hollyshadow.call(this.hollyShadow);
	hollyShadow.x = 750;
	hollyShadow.y = 699;
	hollyShadow.width = 480.00;
	hollyShadow.height = 138.00;
	hollyShadow.alpha = 1.00;
	if (hollyShadow.onLayout) hollyShadow.onLayout();
	const frame = this.frame;
	ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_wcframeLayer221.call(this.frame);
	frame.x = 832;
	frame.y = 384;
	frame.width = 1664.00;
	frame.height = 768.00;
	frame.alpha = 1.00;
	if (frame.onLayout) frame.onLayout();
	const lines = this.lines;
	ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_wcframelines.call(this.lines);
	lines.x = 832;
	lines.y = 369.5;
	lines.width = 1664.00;
	lines.height = 647.50;
	lines.alpha = 0.27;
	if (lines.onLayout) lines.onLayout();
	return this;
}
function ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_background(this: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p17_background", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_outside(this: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_outside) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p17_outside", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_doorframemask(this: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_doorframemask) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p17_doorframemask", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_couch(this: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_couch) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p17_couch", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_outsidelight(this: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_outsidelight) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p17_outsidelight", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_holly(this: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p17_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer196(this: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer196) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer196", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer196copy(this: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer196copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer196copy", 0.496, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer196copy2(this: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer196copy2) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer196copy2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer225(this: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer225) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer225", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer223(this: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer223) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer223", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_hollyshadow(this: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_hollyshadow) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p17_hollyshadow", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p017_hh_ch1_72dpi_p017psdAssettextureLayer135(this: Ich1_p017_hh_ch1_72dpi_p017psdAssettextureLayer135) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer135", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p017_hh_ch1_72dpi_p017psdAssettextureLayer9copy(this: Ich1_p017_hh_ch1_72dpi_p017psdAssettextureLayer9copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer9copy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_wcframeLayer221(this: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_wcframeLayer221) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer221", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_wcframelines(this: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_wcframelines) {
	if (this.setLayoutTexture) this.setLayoutTexture("lines", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich1_p017Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich1_p017Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich1_p017Sprite extends Ich1_p017Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich1_p017Text extends Ich1_p017Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich1_p017Polygon extends Array<number> {
}
interface Ich1_p017 {
	readonly lights: Ich1_p017Array<Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer196|Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer196copy|Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer196copy2|Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer225|Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer223>;
	readonly texture: Ich1_p017Array<Ich1_p017_hh_ch1_72dpi_p017psdAssettextureLayer135|Ich1_p017_hh_ch1_72dpi_p017psdAssettextureLayer9copy>;
	readonly background: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_background;
	readonly outside: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_outside;
	readonly doorFrame: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_doorframemask;
	readonly couch: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_couch;
	readonly outsideLight: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_outsidelight;
	readonly holly: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_holly;
	readonly hollyShadow: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_hollyshadow;
	readonly frame: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_wcframeLayer221;
	readonly lines: Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_wcframelines;
}
interface Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_background extends Ich1_p017Sprite {
}
interface Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_outside extends Ich1_p017Sprite {
}
interface Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_doorframemask extends Ich1_p017Sprite {
}
interface Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_couch extends Ich1_p017Sprite {
}
interface Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_outsidelight extends Ich1_p017Sprite {
}
interface Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_holly extends Ich1_p017Sprite {
}
interface Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer196 extends Ich1_p017Sprite {
}
interface Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer196copy extends Ich1_p017Sprite {
}
interface Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer196copy2 extends Ich1_p017Sprite {
}
interface Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer225 extends Ich1_p017Sprite {
}
interface Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_lightsLayer223 extends Ich1_p017Sprite {
}
interface Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_hollyshadow extends Ich1_p017Sprite {
}
interface Ich1_p017_hh_ch1_72dpi_p017psdAssettextureLayer135 extends Ich1_p017Sprite {
}
interface Ich1_p017_hh_ch1_72dpi_p017psdAssettextureLayer9copy extends Ich1_p017Sprite {
}
interface Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_wcframeLayer221 extends Ich1_p017Sprite {
}
interface Ich1_p017_hh_ch1_72dpi_p017psdAssetch1_p17_wcframelines extends Ich1_p017Sprite {
}
